export const FORM_NAME = {
  /** 就困表单 */
  AFFIRMEMPLOY: 'affirmEmploy'
}